import React from 'react';
import { Link } from 'react-router-dom';
import VideoModal from '../../components/ModalVideo';
import { useTranslation } from 'react-i18next';

const About = (props) => {
    const { t } = useTranslation(); // Import the `useTranslation` hook for i18n

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className={`wpo-about-area section-padding ${props.abClass}`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <img src={props.abimg} alt={t('aboutPage.altText')} />
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-title">
                                <span>{t('aboutPage.subTitle')}</span>
                                <h2>{t('aboutPage.mainTitle')}</h2>
                            </div>
                            <h5>{t('aboutPage.heading')}</h5>
                            <p>{t('aboutPage.description')}</p>
                            <div className="btns">
                                <Link to="/service" onClick={ClickHandler} className="theme-btn">
                                    {t('aboutPage.servicesButton')}
                                </Link>
                                <ul>
                                    <li className="video-holder">
                                        <VideoModal />
                                    </li>
                                    <li className="video-text">{t('aboutPage.videoIntro')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
